import React, { Component } from "react";
import { Container, Row } from "reactstrap";
import Annoncecard from "../../components/common/Hebergement/AnnonceCard";
import NavTab from "../../components/common/global_layout/navTab2";
import AdvancedSearchGhurfaty from '../../components/common/Hebergement/advencedSearchGhurfaty'
import httpClient from '../../httpClient'
import {connect } from 'react-redux';
import CustomCard from '../../components/common/customCard'
import Footer from '../../components/common/global_layout/footer'
import NavTabMobile from "../../components/common/global_layout/navtabMobile";
import HeadMobile from "../../components/common/global_layout/carouselMobile";
import ClipLoader from "react-spinners/ClipLoader";


class Particular extends Component {
  constructor(props){
    super(props);
    this.state = {
     announces:[],
     searchInfo:{},
     isLoading:true,
     searchedResult:true,
     hostName:process.env.REACT_APP_SERVER_URL
    }

  }


  componentDidMount(){
    this.getAllAnnounces();
  }


  componentDidUpdate(prevProps, prevState){
    if(prevProps.advancedSearchParams !== this.props.advancedSearchParams) {
      this.setState({searchInfo:prevProps.advancedSearchParams})
      this.getSearchedAnnounces(this.props.advancedSearchParams).then(res=>{
      });
      }
  }


  getAllAnnounces(){
    return httpClient.getAllHebergAnnounces().then(res=>{
      this.setState({announces:res,isLoading: !this.state.isLoading})
    })
  }

  getSearchedAnnounces(searchParams){
    return httpClient.getSearchedAnnounces(searchParams).then(res=>{
      if(res && res.length>0){this.setState({announces:res});this.setState({searchedResult:true})}
      else if(res.length===0){this.setState({searchedResult:false})}
    })
  }

  
  
  render() {

    const searchNotfound= !this.state.searchedResult;
    console.log(process.env.REACT_APP_SERVER_URL);
    const   HOST_NAME = process.env.REACT_APP_SERVER_URL
    const cards = this.state.announces.map(function(item, i){
      const image="https://cf.bstatic.com/images/hotel/max1024x768/681/68184730.jpg"
      if (1) {
        return (
          <Annoncecard
          key={i}
          rating={item.rating}
          imgPath={`${HOST_NAME}/api/announces/${item._id}/avatar/0`}
          linkPath={`/hebergement/${item._id}/details`}
          hotelName={item.title}
          place={item.region}
          map={item.region}
          idcard={item._id}
        
      />
      )  
      }
      else 
      return (
        <Annoncecard
        key={i}
        rating={item.rating}
        imgPath={`${HOST_NAME}/api/announces/${item._id}/avatar/0`}
        hotelName={item.title}
        place={item.region}
        map={item.region}
        idcard={item._id}
      
    />
    )
  }
  
)
const cards2 = this.state.announces.map(function(item, i){
  const image="https://cf.bstatic.com/images/hotel/max1024x768/681/68184730.jpg"
  if (1) {
    return (
      <Annoncecard
      key={i}
      rating={item.rating}
      imgPath={`${HOST_NAME}/api/announces/${item.photos[0]}/avatar/0`}
      linkPath={`/hebergement/${item._id}/details`}
      hotelName={item.title}
      place={"Dubaii"}
      map={item.region}
      idcard={item._id}
      type = {item.type}
  />
  )  
  }
  else 
  return (
    <Annoncecard
    key={i}
    rating={5}
    imgPath={`${HOST_NAME}/api/announces/${item.photos[0]}/avatar/0`}
    hotelName={item.title}
    place={"Dubaii"}
    map={"Dubai"}
    idcard={item._id}
    type = {item.type}
  
/>
)
}

)
 
    return (
      <>
        <Container>
          <NavTab />
        </Container>

        <HeadMobile />

        <Container>
          <NavTabMobile 
            page="GHURFATY"
            width="150px"
           />
          <AdvancedSearchGhurfaty />
          <Container>
            <div className="custom-card">
              <Row>
                <CustomCard
                  size={3}
                  imgPath={"/imgs/researchtypes/dubai.png"}
                  linkPath={"/"}
                  title={"Hotel"}
                  subtitle={"70000 DZD"}
                />
                <CustomCard
                  size={3}
                  imgPath={"/imgs/researchtypes/bungalo.png"}
                  linkPath={"/"}
                  title={"Appartement"}
                  subtitle={"70000 DZD"}
                />
                <CustomCard
                  size={3}
                  imgPath={"/imgs/researchtypes/appartment.png"}
                  linkPath={"/"}
                  title={"Bungalow"}
                  subtitle={"70000 DZD"}
                />
                <CustomCard
                  size={3}
                  imgPath={"/imgs/researchtypes/otdoors.png"}
                  linkPath={"/"}
                  title={"Outdoos"}
                  subtitle={"70000 DZD"}
                />
              </Row>
            </div>
            {searchNotfound && (
              <div className="search-result">
                <center>
                  <h3>aucun résultat essayer du nouveau</h3>{" "}
                </center>
                <hr />
              </div>
            )}
          </Container>

          <div className="annonces-cards">
            <div className="line-after-search mob"></div>
            <div className="title-big">ANNONCES</div>
            {this.state.isLoading &&
                        <center className="loader-heberg">
                        <ClipLoader  color={"#37296a"} loading={this.state.isLoading } size={50} />
                        </center>
            }
            <Row>
               {cards2} 
            </Row>
          </div>
          <Container></Container>
        </Container>
        {/* <Footer /> */}
      </>
    );
  }
}


function mapStateToProps(state) {
  return {
    // startDate: state.counterApp.startDate,
    // endDate: state.counterApp.endDate,
    /*
    login: state.counterApp.login,
    reserve : state.counterApp.reserve,
    advancedSearchParams:state.counterApp.advancedSearchParams
    */
  }
}
//connect function INJECTS dispatch function as a prop!!
export default connect(mapStateToProps)(Particular);

